import React from "react";
import { Card } from "../../../../components/Card";
import { Loading } from "../../../../components/Loading";
import { TableSimple } from "../../../../components/TableSimple";
import { PlaceHolderNotExists } from "../../../../components/PlaceholderNotExists";
import { useRequestsTable } from "./useRequestTable";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";

const tableHeadHistoric = ["Data pedido", "Status", "Loja", "Itens", "Valor total", "Cupom", ""];

export const Requests: React.FC = () => {
  const {
    loading,
    error,
    requests,
    requestsCount,
    pageNumber,
    requestsPerPage,
    handlePageSelected,
    handleRowsPerPageChange,
  } = useRequestsTable();

  if (loading) {
    return (
      <Card title="Pedidos">
        <Loading />
      </Card>
    )
  }

  if (!loading && requests && requests.length){
    return (
      <Card title="Pedidos">
        <TableModifiedTable
          headerColumns={tableHeadHistoric}
          rows={requests}
        />
        <TableModifiedPagination
          totalItemsCount={requestsCount}
          pageNumber={pageNumber}
          rowsPerPage={requestsPerPage}
          onPageSelected={handlePageSelected}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Card>
    )
  }

  return (
    <Card title="Pedidos">
      <PlaceHolderNotExists title="Usuário não possui pedidos" />
    </Card>
  )
}